<template>
    <div>
        <van-sticky>
            <van-nav-bar title="退款详情" left-arrow @click-left="onClickLeft" />
        </van-sticky>
        <div class="page">
            <!-- 头部状态 -->
            <div  class="describe-box">
                <!-- 申请行进流程 -->
                <div  class="process">
                    <!-- 提交申请 -->
                    <div  class="current-process" v-if="returnMoneySts == 1">退款申请待商家处理</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == 1">你已成功发起退款申请，等待商家处理</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == 1">{{updateTime}}</div>
                    <!-- 商家拒绝 -->
                    <div  class="current-process" v-if="returnMoneySts == 7">商家不同意退款申请</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == 7">你可以修改退款申请或申请客服介入</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == 7">{{updateTime}}</div>
                    <!-- 商家同意退款 -->
                    <div  class="current-process" v-if="returnMoneySts == 2">商家同意退款</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == 2 && applyType == 1">商家已同意，等待系统退款</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == 2 && applyType == 2">商家已同意，请按照商家给出的退货地址寄回商品</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == 2">{{updateTime}}</div>
                    <!--  寄出商品（退货退款情况下） -->
                    <div  class="current-process" v-if="returnMoneySts == 3">等待商家确认收货并退款</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == 3">你已退货，商家将在收货后尽快处理</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == 3">{{updateTime}}</div>
                    <!-- 商家确认收货 -->
                    <div  class="current-process" v-if="returnMoneySts == 4">商家确认收货</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == 4">商家已确认收货，等待系统退款</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == 4">{{updateTime}}</div>
                    <!-- 退款成功 -->
                    <div  class="current-process" v-if="returnMoneySts == 5">
                        <div  style="display: flex;align-items: center;">
                            <img style="width: 25px;height: 25px;" src="http://img.zhujiaxian.com/2023/11/805a39abf29244379a8bf8837209bbce.png" alt="">
                            <span>退款完成</span>
                        </div>
                    </div>
                     <!-- 退款申请关闭 -->
                    <div  class="current-process" v-if="returnMoneySts == -1">退款申请关闭</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == -1"> {{rejectMessage?rejectMessage:''}}</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == -1">{{updateTime}}</div>
                    <!-- 买家撤回申请 -->
                    <div  class="current-process" v-if="returnMoneySts == 6">申请已撤回</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == 6"> {{rejectMessage?rejectMessage:''}}</div>
                    <div  class="acount-for-process" v-if="returnMoneySts == 6">{{updateTime}}</div>
                </div>
            </div>
            <!-- 头部状态end -->
            <div class="describe-box1" style="display:flex;position: relative;border-radius: 12px;">
                <span style="color:#747876;font-size:14px;">退款已处理完成，实际退款到账时间因支付方式不同可能稍有延迟，请耐心等候</span>
            </div>
              <!-- 【退款申请被拒绝时显示】拒绝理由 -->
            <div class="refuse-reason" v-if="returnMoneySts == 7">
                拒绝理由：{{rejectMessage}}
            </div>
              <!-- 【退货退款状态下，买家同意后】退货地址 -->
            <div class="return-address" v-if="returnMoneySts == 2 && applyType == 2">
                <div class="addr-tit">退货地址</div>
                <div class="address">
                <div class="recipient">
                    <span class="addr-cont">收件人：{{refundDelivery.receiverName}}</span>
                    <span class="mobile">{{refundDelivery.receiverMobile}}</span>
                </div>
                <div class="addr">详细地址：{{refundDelivery.receiverAddr}}</div>
                </div>
            </div>
            <!-- 退款信息 -->
            <div class="refund-message">
                <div class="refund-txt">
                <div style="display:flex;justify-content:space-between;align-items: center;">
                <span>退款信息</span>
                <!-- <div style="display:flex;justify-content:end;align-items: center;">
                    <img style="width: 30rpx;height: 30rpx;" src="http://img.zhujiaxian.com/2023/11/a440e4ee1621411db19b705f78f186f9.png" mode="aspectFit"/>
                    <button  class='contact-merchant' open-type="contact">联系客服</button>
                </div> -->
                </div>
                </div>
                <div class="goods-msg-box">
                <!-- 图片 -->
                <div class="img-box" v-if="orderItems.length==1">
                    <img :src="orderItems[0].pic" /> 
                </div>
                <!-- 信息 -->
                <div class="goods-text" v-if="orderItems.length==1">
                    <div class="goods-title">{{orderItems[0].prodName}}</div>
                    <div class="goods-quantity">数量：{{orderItems[0].prodCount}}件</div>
                </div>
                <div v-if="orderItems.length>1">
                    <div class="refund-goods-item" v-for="(item,index) in orderItems" :key="index">
                    <!-- 图片 -->
                    <div class="img-box">
                        <img :src="item.pic" />
                    </div>
                    <!-- 信息 -->
                    <div class="goods-text">
                        <div class="goods-title">{{item.prodName}}</div>
                        <div class="goods-quantity">数量：{{item.prodCount}}件</div>
                    </div>
                    </div>
                </div>

                </div>
                <div>
                <div class="refund-cont" style="background:#F1F1F1;border-radius:7px;line-height:2.5em;padding:0px 10px;margin: 0px 0px 10px 0px;">退款原因：{{buyerReason}}</div>
                </div>
                <!-- 具体信息 -->
                <div class="refund-cont">退款方式：<span style="color: #0D1401;">{{['','仅退款','退货退款'][applyType]}}</span></div>
                <div class="refund-cont">退款金额：<span class="red">￥{{refundAmount}}</span></div>
                <div class="refund-cont">退款编号：<span style="color: #0D1401">{{refundSn}}</span></div>
                <div class="refund-cont">申请时间：<span style="color: #0D1401;">{{applyTime}}</span></div>
                <!-- 【退货申请显示】 -->
                <div class="refund-cont" v-if="goodsNum!=0">退货数量：{{goodsNum}}</div>
                <!-- 联系商家 -->   
                
            </div>
              <!-- 脚部撤销申请 -->
            <!-- applyType: 1,  //申请类型:1,仅退款,2退款退货 -->
            <!-- returnMoneySts： 处理退款状态:(1.买家申请 2.卖家接受 3.买家发货 4.卖家收货 5.退款成功 6.买家撤回申请 7.商家拒绝 -1.退款关闭) -->
            <div class="foot-box">
                <div class="footer">
                <!-- 【申请后-申请完成前】 -->
                <span class="undo-apply" @click="cancelApplication"  v-if="returnMoneySts ==1 || returnMoneySts == 7 || (returnMoneySts ==2 && applyType == 2)" >撤销申请</span>
                <!-- 【商家拒绝时显示】 -->
                <!-- <text class="undo-apply apply-current" bindtap="toAlterRefundApply" wx:if="{{returnMoneySts ==1 || returnMoneySts == 7}}" data-refundsn="{{refundSn}}">修改申请</text> -->
                <!-- 【商家同意后-货物寄出前】 -->
                <!-- 在模板中找到填写退货物流按钮的位置 -->
                <span class="undo-apply apply-current" 
                      v-if="returnMoneySts == 2 && applyType == 2"
                      @click="goToWriteLogistics">填写退货物流</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { GetorderRefundinfo,GetorderRefundcancel } from "@/https/http";
import { Dialog } from 'vant';  // 添加这行
export default {
    data(){
        return{
            showView: true,  //隐藏是展示
            applyTime: '',  //申请时间
            applyType: 1,  //申请类型:1,仅退款,2退款退货
            goodsNum: '',  //退货数量
            handelTime: '',  //卖家处理时间
            orderAmount: '',  //订单总金额
            orderItems: {},  //订单项 
            refundAmount: '',  //退款金额
            refundDelivery: [],  //收货地址对象
            refundId: '',  //记录ID
            refundTime: '',  //退款时间
            returnMoneySts: 1, //处理退款状态:(1.买家申请 2.卖家接受 3.买家发货 4.卖家收货 5.退款成功 6.买家撤回申请 7.商家拒绝 -1.退款关闭)
            updateTime: '',  //更新时间
            refundSn: '',  //退款编号
            rejectMessage: '',  //拒绝理由
            buyerReason: '',  //退款原因
        }
    },
    created(){
        let o = this.$route.query.o
        //获取退款申请详情
        this.getRefundDetail(o)
    },
    methods:{
        onClickLeft(){
            this.$router.go(-1);
        },
        // 添加跳转方法
        goToWriteLogistics() {
            this.$router.push({
                path: '/writeReturnLogistics',
                query: {
                    o: this.refundSn
                }
            });
        },
        cancelApplication() {
            Dialog.confirm({
                title: '撤销',
                message: '确定要撤销本次申请？',
            })
            .then(() => {
                // 点击确定按钮
                GetorderRefundcancel(this.refundSn).then(res => {
                    this.$toast.success(res);
                    this.$router.push('/afterSales');
                }).catch(err => {
                    this.$toast.fail('撤销失败');
                });
            })
            .catch(() => {
                // 点击取消按钮
                console.log('取消撤销');
            });
        },
        getRefundDetail(o){
            GetorderRefundinfo(o).then(res=>{
                console.log(res.data.orderItems);
                this.applyTime= res.data.applyTime;  //申请时间
                this.applyType= res.data.applyType;  //申请类型:1,仅退款,2退款退货
                this.goodsNum= res.data.goodsNum;  //退货数量
                this.handelTime= res.data.handelTime; //卖家处理时间
                this.orderAmount= res.data.orderAmount;  //订单总金额
                this.orderItems= res.data.orderItems;  //订单项 
                this.refundSn= res.data.refundSn;  //退款编号
                this.refundAmount= res.data.refundAmount;  //退款金额
                this.refundDelivery= res.data.refundDelivery;  //收货地址对象
                this.refundId= res.data.refundId; //记录ID
                this.refundTime= res.data.refundTime;  //退款时间
                this.returnMoneySts= res.data.returnMoneySts; //处理退款状态:(1.买家申请 2.卖家接受 3.买家发货 4.卖家收货 5.退款成功 6.买家撤回申请 7.商家拒绝 -1.退款关闭)
                this.updateTime= res.data.updateTime;  //更新时间
                this.rejectMessage= res.data.rejectMessage;  //拒绝理由
                this.buyerReason= res.data.buyerReason; //退款原因
            })
        },
    }
}
</script>
<style lang="less">
/* pages/DetailsOfRefund/DetailsOfRefund.wxss */
.display {
  display: none;
}
img {
  width: 100%;
  height: 100%;
}
.page {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #F4F7FF;
}
/* 头部状态 */
.describe-box {
  /* background: #fff; */
  margin-bottom: 10px;
  margin: 0px 10px;
}
.describe-box1{
 background: #fff;
 padding: 10px 13px;
 margin: 0px 10px;
 margin-bottom: 10px;
}
.process {
  padding: 10px 13px;
  border-bottom: 1px solid #f2f2f2;
}
.current-process {
  font-size: 15px;
  font-weight: bold;
  padding: 5px 0;
}
.acount-for-process {
  font-size: 13px;
  color: #444;
  line-height: 1.5em;
}
.red {
  color: red;
}

/* 整单退款商品列表 */
.refund-goods-item{
  padding: 10px 0;
  border-bottom: 1px solid #ddd;
}
.refund-goods-item:last-child{
  border-bottom:none;
}

/* 隐藏内容 */
.more-content {
  border-top: 1px dashed #ebebeb;
  margin-top: 7px;
  padding-top: 5px;
}
.cont {
  font-size: 17px;
  color: #777;
  line-height: 1.8em
}
/* 更多说明 */
.more-instructions {
  padding: 5px 0;
  padding-bottom: 7px;
  text-align: center;
  font-size: 13px;
}
.more-txt {
  vertical-align: middle;
}
.down-arrow-icon {
  display: inline-block;
  width: 20px;
  height: 13px;
  vertical-align: middle;
}


/* 退款流程 */
.refund-schedule {
  background: #fff;
  margin-bottom: 10px;
  padding: 0 13px;
}
.refund-sum {
  font-size: 14px;
  padding: 13px 0;
  border-bottom: 1px solid #f2f2f2;
}
.progress-bar {
  position: relative;
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
}
.block {
  display: inline-block;
  text-align: center;
}
.round {
  display: block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #999999;
  margin: 0 auto;
  margin-top: 7px;
}
/* 激活状态圆点 */
.round-current {
  background: #3388ff;
}
.block-text {
  margin-top: 7px;
  text-align: center;
}
.block-text-tit {
  font-size: 13px;
  line-height: 2em;
  color: #777;
}
.block-text-time {
  font-size: 11px;
  color: #aaa;
}
.line {
  position: absolute;
  top: 19px;
  display: inline-block;
  width: 107px;
  height:2.5px;
  background: #bdbdbd;
}
/* 激活状态直线 */
.line-current {
  background: #3388ff;
}
.line01 {
  left: 73px;
}
.line02 {
  right: 63px;
}

/* 拒绝理由 */
.refuse-reason {
  font-size: 14px;
  background: #fff;
  padding: 10px;
  margin-bottom: 10px;
}


/* 退货地址 */
.return-address {
  background: #fff;
  margin-bottom: 10px;
}
.addr-tit {
  padding:5px 10px;
  border-bottom: 1px solid #f2f2f2;
  font-size: 14px;
}
.address {
  padding: 10px;
  font-size: 13px;
}
.recipient {
  padding-bottom: 5px;
}
.mobile {
  margin-left: 25px;
}

/* 退款信息 */
.refund-message {
  background: #fff;
  padding: 10px 13px;
  margin: 0px 10px;
}
.refund-txt {
  font-size: 14px;
  margin-bottom: 13px;
}

/* 商品信息 */
.goods-msg-box {
  background: #f9f9f9;
  padding: 7px 10px;
  margin: 7px 0;
}
.img-box {
  display: inline-block;
  width: 75px;
  height: 75px;
  margin-right: 10px;
  /* background: #eee; */
  vertical-align: top;
  border: 1px solid #EEEEEE;
  border-radius: 12px;
  padding: 10px;
}
.goods-text {
  display: inline-block;
  vertical-align: top;
  width: 65%;
}
.goods-title {
  font-size: 14px;
}
.goods-quantity {
  font-size: 14px;
  color: #aaa;
  margin-top: 10px;
}
/* 具体信息 */
.refund-cont {
  font-size: 12px;
  color: #777;
  line-height: 2em;
}
/* 联系商家 */
.contact-merchant {
  font-size: 14px;
  color: #71BF15;
  text-align: center;
  padding: 0px;
  /* width: 90px; */
  margin: 0px;

  /* padding-top: 20rpx;
  margin-top: 20rpx;
  border-top: 1rpx solid #f2f2f2;
  line-height: 1.5em; */
}
button.contact-merchant{
  background: #fff;
}
button.contact-merchant::after{
  border:0;
}


/* 脚部撤销 */
.foot-box {
  display: block;
  margin-top: 75px;
}
.footer {
  display: block;
  box-sizing: border-box;
  position: fixed;
  width: 100%;
  bottom: 0;
  font-size: 14px;
  background: #fff;
  padding: 0 15px;
  text-align: right;
  box-shadow: 1px 5px 5px 5px rgb(236, 236, 236);
}
.undo-apply {
  display: inline-block;
  box-sizing: border-box;
  padding: 7px 10px;
  font-size: 12.5px;
  border-radius:2px;
  margin: 13px 0;
  margin-left: 7px;
  border: 1px solid #eee;
  color: #777;
}
.undo-apply-end {
  display: inline-block;
  box-sizing: border-box;
  margin-left: 7px;
  color: #777;
  font-size: 15px;

}
.apply-current {
  border: 1px solid rgb(0, 173, 0);
  color: rgb(0, 173, 0);
  
}
</style>